import { connect } from 'react-redux';
import DuplicateModal from './DuplicateModal';
import { duplicateAirHandlingUnit } from '../../redux/ac_central/air_handling_unit_actions';

const mapStateToProps = state => ({
  isDuplicating: state.ac.airHandlingUnit.isDuplicating,
  errorMessage: state.ac.airHandlingUnit.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateAirHandlingUnit(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/duplicate/AirHandlingUnitDuplicateModal.js